// src/pages/customer/Privacy.jsx
import React from "react";
import { Helmet } from "react-helmet-async";

const sections = [
  {
    title: "1. Information We Collect",
    intro: "We collect the following types of information:",
    points: [
      "Personal Information: When you register, place an order, or interact with our site, we may collect your name, email address, phone number, and shipping address.",
      "Technical Information: We collect information such as your IP address, browser type, and device details to improve your user experience.",
      "Cookies: We use cookies to enhance website functionality, remember your preferences, and track website performance.",
    ],
  },
  {
    title: "2. How We Use Your Information",
    points: [
      "Process and manage orders (Cash on Delivery only)",
      "Provide customer support",
      "Enhance our website and services",
      "Send you promotional offers, updates, or notifications (only if you opt in)",
    ],
  },
  {
    title: "3. Firebase and Data Storage",
    body: "Our website is developed using HTML, CSS, and JavaScript, and we use Firebase as our database to store and manage data. Firebase complies with the General Data Protection Regulation (GDPR), ensuring that your data is stored securely with industry-standard encryption protocols.",
  },
  {
    title: "4. How We Protect Your Information",
    body: "We implement SSL encryption and industry-standard security measures to protect your personal data. Access to your data is restricted to authorized personnel, and we maintain strict data protection practices.",
  },
  {
    title: "5. Cash on Delivery (COD)",
    body: "We do not process any online payments. All orders placed on our website are Cash on Delivery (COD) only. No payment information is collected or stored on our platform.",
  },
  {
    title: "6. GDPR Compliance",
    intro: "If you are located in the European Union (EU), we comply with the General Data Protection Regulation (GDPR). You have the following rights:",
    points: [
      "Access: You can request access to your personal data.",
      "Correction: You can request corrections to inaccurate or incomplete data.",
      "Erasure: You can request deletion of your data under specific circumstances.",
      "Restriction: You can ask us to restrict the processing of your data.",
      "Portability: You can request a copy of your data in a machine-readable format.",
    ],
  },
  {
    title: "7. Children's Privacy",
    body: "Our website is not intended for children under 13 years old. We do not knowingly collect personal information from children.",
  },
  {
    title: "8. Changes to This Policy",
    body: "We may update this Privacy Policy from time to time. Any changes will be reflected on this page with an updated effective date.",
  },
];

export default function Privacy() {
  return (
    <div style={{ background: "#f7f3e3" }}>
      <Helmet>
        <title>Privacy Policy | Tripura Agro</title>
        <meta
          name="description"
          content="Tripura Agro Industries was established in 2022 with the goal of leveraging supply and demand between farmers and Mandis at the national level and the final customer, who may be an individual or an institution."
        />
      </Helmet>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">

        <h1
          className="font-bold uppercase mb-8"
          style={{
            fontSize: "clamp(1.5rem, 3vw, 2rem)",
            color: "#2d3a1e",
            letterSpacing: "0.06em",
          }}
        >
          Privacy Policy
        </h1>

        <p className="text-sm sm:text-base leading-relaxed mb-10" style={{ color: "#444" }}>
          At Tripura Agro Industries OPC Pvt. Ltd., we are committed to safeguarding your privacy
          and ensuring the protection of your personal information. This Privacy Policy explains
          how we collect, use, and protect your data when you visit our website or use our services.
        </p>

        <div className="space-y-9">
          {sections.map((s) => (
            <div key={s.title}>
              <h2
                className="font-bold uppercase mb-3"
                style={{ fontSize: "1rem", color: "#2d3a1e", letterSpacing: "0.04em" }}
              >
                {s.title}
              </h2>

              {s.intro && (
                <p className="text-sm sm:text-base leading-relaxed mb-3" style={{ color: "#444" }}>
                  {s.intro}
                </p>
              )}

              {s.body && (
                <p className="text-sm sm:text-base leading-relaxed" style={{ color: "#444" }}>
                  {s.body}
                </p>
              )}

              {s.points && (
                <ul className="space-y-2">
                  {s.points.map((p, i) => (
                    <li
                      key={i}
                      className="text-sm sm:text-base leading-relaxed pl-5 relative"
                      style={{ color: "#444" }}
                    >
                      <span
                        className="absolute left-0"
                        style={{ color: "#4a6e30" }}
                      >
                        •
                      </span>
                      {p}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}

          {/* Contact section */}
          <div>
            <h2
              className="font-bold uppercase mb-3"
              style={{ fontSize: "1rem", color: "#2d3a1e", letterSpacing: "0.04em" }}
            >
              9. Contact Us
            </h2>
            <p className="text-sm sm:text-base leading-relaxed" style={{ color: "#444" }}>
              If you have any questions or concerns regarding this Privacy Policy, please contact us at:
            </p>
            <p className="text-sm sm:text-base leading-relaxed mt-2" style={{ color: "#444" }}>
              Tripura Agro Industries OPC Pvt. Ltd.<br />
              Mail Id:{" "}
              <a href="mailto:sandeep@tripuraagro.com" style={{ color: "#4a6e30", fontWeight: 600 }}>
                sandeep@tripuraagro.com
              </a>
              <br />
              Contact No.:{" "}
              <a href="tel:+919778553533" style={{ color: "#4a6e30", fontWeight: 600 }}>
                +91 9778553533
              </a>
            </p>
          </div>
        </div>

      </div>
    </div>
  );
}